import config from 'config'
import lang from '@/lang'
import { ECONOMIC_ASSET_QUICK_FILTER } from './constants'

const url = 'economicAssets'

export default {

  resourceUrl: `${config.resourceHost}${url}`,

  assetListSetting: `${config.resourceHost}setting/userlist/economicAsset`,

  clientUrl: url,

  routes: {
    details: (id) => `/${url}/${id}`,
    list: `${config.resourceHost}${url}`,
    new: `/${url}`,
  },

  filters: [
    {
      name: 'all',
      title: lang.label.allCapital,
      quickFilter: null,
    },
    {
      name: ECONOMIC_ASSET_QUICK_FILTER.LT_TWO_YEARS,
      title: lang.economicAsset.quickFilter[ECONOMIC_ASSET_QUICK_FILTER.LT_TWO_YEARS],
      quickFilter: {
        remainingEconomicLifeInMonths: {
          filterType: 'number',
          type: 'lessThan',
          filter: 24,
        },
      },
    },
    {
      name: ECONOMIC_ASSET_QUICK_FILTER.GT_TWO_YEARS,
      title: lang.economicAsset.quickFilter[ECONOMIC_ASSET_QUICK_FILTER.GT_TWO_YEARS],
      quickFilter: {
        remainingEconomicLifeInMonths: {
          filterType: 'number',
          type: 'greaterThan',
          filter: 24,
        },
      },
    },
    {
      name: ECONOMIC_ASSET_QUICK_FILTER.FULLY_DEPRECIATED,
      title: lang.economicAsset.quickFilter[ECONOMIC_ASSET_QUICK_FILTER.FULLY_DEPRECIATED],
      quickFilter: {
        status: {
          type: 'set',
          values: [ECONOMIC_ASSET_QUICK_FILTER.FULLY_DEPRECIATED],
        },
      },
    },
    {
      name: ECONOMIC_ASSET_QUICK_FILTER.COMPLETED,
      title: lang.economicAsset.quickFilter[ECONOMIC_ASSET_QUICK_FILTER.COMPLETED],
      quickFilter: {
        status: {
          type: 'set',
          values: [ECONOMIC_ASSET_QUICK_FILTER.COMPLETED],
        },
      },
    },
  ],
}
